/**
 * Returns the number of buttons that can be displayed in the container
 */
export const getVisibleCount = (
  buttonWidths: number[],
  lines: number,
  gap: number,
  moreWidth: number,
  containerWidth: number,
  selectedIndex: number
) => {
  let count = 0
  let sort = false
  for (let line = 0; line < lines; line++) {
    const lineCount = getVisibleCountLine(
      buttonWidths.slice(count),
      gap,
      moreWidth,
      containerWidth,
      line === lines - 1
    )
    count += lineCount
  }

  if (selectedIndex >= count) {
    /**
     * This means that the selected item is not visible in the current layout
     * We need to recalculate the count with the selected item
     */
    const newButtonWidths = [
      buttonWidths[selectedIndex],
      ...buttonWidths.slice(0, selectedIndex),
      ...buttonWidths.slice(selectedIndex + 1),
    ]

    count = 0
    for (let line = 0; line < lines; line++) {
      const lineCount = getVisibleCountLine(
        newButtonWidths.slice(count),
        gap,
        moreWidth,
        containerWidth,
        line === lines - 1
      )
      count += lineCount
    }

    sort = true
  }

  return { count, sort }
}

export const getVisibleCountLine = (
  buttonWidths: number[],
  gap: number,
  moreWidth: number,
  containerWidth: number,
  isLastLine: boolean
) => {
  let count = 0
  let remainingWidth = containerWidth

  while (remainingWidth > 0) {
    const btnWidth = count === 0 ? buttonWidths[count] : buttonWidths[count] + gap
    if (remainingWidth - btnWidth < 0) {
      break
    }
    remainingWidth -= btnWidth
    count++
  }

  if (isLastLine && count > 0) {
    while (remainingWidth < moreWidth + gap) {
      count--
      remainingWidth += gap + buttonWidths[count]
    }
  }

  return count
}
